export default {
  HI: 'Hi {{ name }}!',
  RETURN_HOME: 'Return Home',
  RETURN_DASHBOARD: 'Go to Dashboard',
  MY_PROFILE: 'My Profile',
  MY_NOTIFICATIONS: 'My Notifications',
  MY_SETTINGS: `My Settings`,
  CHANGE_LANGUAGE: 'Français',
  LOG_OUT: 'Log out',
  SWITCH_TO_OLD_VERSION: 'Switch to old application',
  NEXT_SHIFT_IS: 'This is your next shift',
  SHIFT_JUST_ENDED: `This shift just ended`,
  SHIFT_STARTED_AT: `Today's shift`,
  NO_UPCOMING_SHIFTS: 'You have no upcoming shifts',
  EMOJI_MODAL: {
    TITLE: 'Welcome to Merinio Zoo!',
    SUMMARY: 'Select the animal that best represents you.'
  },
  IMPORTANT_INFORMATION_MODAL: {
    TITLE: `Important information`,
    SUMMARY: ``,
    USERNAME: `Username`,
    EMPLOYEE_NUMBER: `Employee number`,
    TWILIO_PHONE: `Phone system number`,
    COMPANY_ID: `Company id (beginning of url for mobile app)`,
    HELP_CENTER: `Help center`
  },
  EMPLOYEE: `Me`,
  MANAGER: `Manage`,
  ADMINISTRATION: `Admin`,
  SEE_MY: `See mine`,
  UNABLE_TO_LOAD_NEXT_SHIFT: `Unable to load your next shift`
}
